export default __webpack_public_path__ + "79059411d07c93396e768950b03585bc.png";